<template>
  <router-link :to="go_to()" class="client_request link">
    <tr>
      <td :data-label="translate('client_request.request_type')" class="">
        <span class="badge" :style="'background-color: ' + new_request_type.color">
          {{ new_request_type.title }}
        </span>
      </td>
      <td :data-label="translate('client_request.status')" class="">
        <span class="badge" :style="'background-color: ' + new_request_status.color">
          {{ new_request_status.title }}
        </span>
      </td>
      <td :data-label="translate('client_request.device_name')" class="device_name">
        <router-link :to="{path: '/device/' + client_simcard_request.device_fid}">
          {{ client_simcard_request.device_fid }}
        </router-link>
        <p>{{ client_simcard_request.device_name }}</p>
      </td>
      <td :data-label="translate('client_request.simcard_list.oper_name')" @click.stop="">
        <a
            v-if="client_simcard_request.mno_link && $store.getters.getPermissions.permissionGod === true"
            :href="client_simcard_request.mno_link"
            target="_blank"
            class="pointer"
        >
          {{ client_simcard_request.oper_name }}
        </a>
        <template v-else>
          {{ client_simcard_request.oper_name }}
        </template>
      </td>
      <td :data-label="translate('client_request.simcard_list.msisdn')" class="">
        {{ client_simcard_request.msisdn }}
      </td>
      <td :data-label="translate('client_request.simcard_list.imsi')" class="">
        {{ client_simcard_request.imsi }}
      </td>
      <td :data-label="translate('client_request.simcard_list.iccid')" class="">
        {{ client_simcard_request.iccid}}
      </td>
      <td :data-label="translate('simcard_profile.status')" style="">
        <span class="badge" :class="global_status_color(client_simcard_request.profile_status)">
            {{ translate(global_status_text(client_simcard_request.profile_status)) }}
        </span>
      </td>
      <td :data-label="translate('client_request.updated')" class="">
        {{ get_date(client_simcard_request.ts_update) }}
      </td>
    </tr>
  </router-link>
</template>
<script>

export default {
  name: 'ClientRequestListItem',
  components: {
  },
  props: ["client_simcard_request", "client_order_statuses"],
  data () {
    return {
    }
  },
  computed:{
    new_request_status(){
      let result = this.$store.getters.getClientRequestsInfo.statuses.find((entry) => {
        if (entry.id === this.client_simcard_request.request_status){
          return entry
        }
      })
      return result ? {...result, title: this.translate("client_request.statuses." + result.title) } : {title: "Error", color: "red"}
    },
    new_request_type(){
      let result = this.$store.getters.getClientRequestsInfo.types.find((entry) => {
        if (entry.id === this.client_simcard_request.request_type){
          return entry
        }
      })
      return result ? {...result, title: this.translate("client_request.types." + result.title) } : {title: "Error", color: "red"}
    }
  },
  methods: {
    go_to() {
      return { path: '/client_request/' + this.client_simcard_request.client_request_id }
    },
    add_in_filter (type, value) {
      let params = {
        type: type,
        value: value
      }
      this.$emit("add_in_filter", params)
    }

  }
}
</script>

<style lang="scss" scoped>
.client_request{
  cursor: pointer;
  color: #252422;
  &:hover{
    tr{
      background-color: #eee;
    }
  }
  td{
    overflow: hidden;
    vertical-align: middle;
    &.limit{
      width: 10%;
      min-width: 100px;
      @media (max-width: 767px) {
        width: 100%;
      }
    }
    &.device_status{
      width: 120px;
      font-size: 18px;
      vertical-align: middle;
      .mdi-access-point{
        color: #00a254;
      }
      @media (max-width: 767px) {
        font-size: 12px;
      }
    }
    &.device_tariff{
      width: 120px;
      color: #3f93d3;
      font-size: 18px;
      vertical-align: middle;
      @media (max-width: 767px) {
        font-size: 12px;
      }
    }
  }

  .device_name{
    a,p{
      font-size: 12px;
      margin-bottom: 0;
    }
  }
}
</style>
